<template>
  <v-row justify="center">
    <v-col cols="6">
      <GroupProfileComponent
        v-model="groupProfileData"
        @created="onCreated"
        @deleted="onDeleted"
        @edited="onEdited">

        <template v-slot:cooperations.warning-left>
          <WarningLeftExample/>
        </template>
        <template v-slot:cooperations.warning-right>
          <WarningRightExample/>
        </template>

        <template v-slot:cooperationRequests.warning-left>
          <WarningLeftExample/>
        </template>
        <template v-slot:cooperationRequests.warning-right>
          <WarningRightExample/>
        </template>

        <template v-slot:members.warning-left>
          <WarningLeftExample/>
        </template>
        <template v-slot:members.warning-right="{data}">
          <WarningRightWitchEditorExample :dataRef="data"/>
        </template>

      </GroupProfileComponent>
    </v-col>
  </v-row>
</template>

<script>

import GroupProfileComponent from "@/components/group/profile/GroupProfileComponent";
import {reactive} from "@vue/composition-api";
import {displayables, states} from "@/components/group/profile/GroupSingleLineComponent";
import WarningLeftExample from "@/components/group/profile/warning/WarningLeftExample";
import WarningRightExample from "@/components/group/profile/warning/WarningRightExample";
import WarningRightWitchEditorExample from "@/components/group/profile/warning/WarningRightWitchEditorExample";

export default {
  name: "GroupProfileView",
  components: {WarningRightWitchEditorExample, WarningRightExample, WarningLeftExample, GroupProfileComponent},
  setup() {

    let cooperationDisplayConfiguration = {}
    cooperationDisplayConfiguration[states.DELETE] = [displayables.WARNING_HARD]

    let cooperationRequestDisplayConfiguration = {}
    cooperationRequestDisplayConfiguration[states.DELETE] = [displayables.WARNING_SOFT]
    cooperationRequestDisplayConfiguration[states.CREATE] = [displayables.WARNING_HARD]

    let membersDisplayConfiguration = {}
    membersDisplayConfiguration[states.EDIT] = [displayables.WARNING_HARD]
    membersDisplayConfiguration[states.DELETE] = [displayables.WARNING_SOFT]

    let invitationDisplayConfiguration = {}
    invitationDisplayConfiguration[states.DELETE] = [displayables.WARNING_SOFT]

    const groupProfileData = reactive([
      {
        name: 'cooperations',
        title: 'Kooperationen',
        showEditIcon: false,
        fallbackIcon: '$cooperationPlus',
        displayForState: cooperationDisplayConfiguration,
        data: [
          {
            value: {
              text: 'corinna.taler@talerag.de',
              state: states.DEFAULT
            },
            imgSrc: 'https://picsum.photos/32?random=1'
          },
          {
            value: {
              text: 'lt.@cold3548.io',
              state: states.DEFAULT
            }
          },
          {
            value: {
              text: 'colmar@schulte.de',
              state: states.DEFAULT
            }
          }
        ]
      },
      {
        name: 'cooperationRequests',
        title: 'Kooperationsanfragen',
        showEditIcon: false,
        showNewButton: true,
        newButtonText: 'Neue Kooperation',
        softWarningText: 'Kooperationsanfrage entfernen?',
        fallbackIcon: '$cooperationPlus',
        displayForState: cooperationRequestDisplayConfiguration,
        data: [
          {
            value: {
              text: 'corinna.taler@talerag.de',
              state: states.DEFAULT
            },
            imgSrc: 'https://picsum.photos/32?random=1'
          },
          {
            value: {
              text: 'cold3548',
              state: states.DEFAULT
            }
          },
          {
            value: {
              text: 'cold3548',
              state: states.DEFAULT
            }
          }
        ]
      },
      {
        name: 'members',
        title: 'Mitglieder',
        softWarningText: 'Nutzer entfernen?',
        fallbackIcon: '$person',
        displayForState: membersDisplayConfiguration,
        data: [
          {
            value: {
              text: 'Corinna Taler',
              state: states.DEFAULT
            },
            imgSrc: 'https://picsum.photos/32?random=2',
            admin: false
          },
          {
            value: {
              text: 'Liv Taylor',
              state: states.DEFAULT
            },
            admin: false
          },
          {
            value: {
              text: 'Peter Paulsen',
              state: states.DEFAULT
            },
            admin: true
          },
          {
            value: {
              text: 'Carmen Nebel',
              state: states.DEFAULT
            },
            admin: false
          }
        ]
      },
      {
        name: 'invitations',
        title: 'Einladungen',
        showEditIcon: false,
        showNewButton: true,
        newButtonText: 'Neue Einladung',
        softWarningText: 'Einladung zurückziehen?',
        fallbackIcon: '$invitation',
        displayForState: invitationDisplayConfiguration,
        data: [
          {
            value: {
              text: 'corinna.taler@talerag.de',
              state: states.DEFAULT
            },
            imgSrc: 'https://picsum.photos/32?random=3'
          },
          {
            value: {
              text: 'lt.@cold3548.io',
              state: states.DEFAULT
            }
          },
          {
            value: {
              text: 'peter@paulsen-gruppe.com',
              state: states.DEFAULT
            }
          },
          {
            value: {
              text: 'carmen@nebel-ag.de',
              state: states.DEFAULT
            }
          }
        ]
      }
    ])


    function onCreated(dataObject, slotIndex, dataIndex) {
      console.log('created: ', dataObject, groupProfileData[slotIndex].title, dataIndex)
    }

    function onDeleted(dataObject, slotIndex, dataIndex) {
      console.log('deleted: ', dataObject, groupProfileData[slotIndex].title, dataIndex)
    }

    function onEdited(dataObject, slotIndex, dataIndex) {
      console.log('edited: ', dataObject, groupProfileData[slotIndex].title, dataIndex)
    }

    return {groupProfileData, onCreated, onDeleted, onEdited}
  }
}
</script>

<style scoped>



</style>
